// **** Generated File: Do NOT edit!  **********
// Generated from java class: com.abinitio.webcommons.abweb.dto.download.DownloadStatus
// using template webcommons/abinitio/build/codegen/src/main/resources/tsTemplates/TSEnum.vm
// If you need to 'extend' the enum, create another file with module of the same name and add functions to it...

export let DownloadStatus = /*#__PURE__*/function (DownloadStatus) {
  DownloadStatus[DownloadStatus["INCOMPLETE"] = 0] = "INCOMPLETE";
  DownloadStatus[DownloadStatus["CANCELLED"] = 1] = "CANCELLED";
  DownloadStatus[DownloadStatus["ERROR"] = 2] = "ERROR";
  DownloadStatus[DownloadStatus["SUCCEEDED"] = 3] = "SUCCEEDED";
  return DownloadStatus;
}({});
(function (_DownloadStatus) {
  function fromJson(enumVal) {
    // Canonically always return numeric representation of enum (NOT a string!)
    // An enumVal of either string or number will return undefined if invalid (out of range)
    return typeof enumVal === "number"
    // For safety, check for number in range, if not return undefined
    ? DownloadStatus[enumVal] != null ? enumVal : undefined : DownloadStatus[enumVal];
  }
  _DownloadStatus.fromJson = fromJson;
  function name(enumIndex) {
    return this[enumIndex];
  }
  _DownloadStatus.name = name;
  function indexOf(enumVal) {
    return enumVal; // Erasure....
  }
  _DownloadStatus.indexOf = indexOf;
})(DownloadStatus || (DownloadStatus = {}));
//# sourceMappingURL=DownloadStatus.js.map
